import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import { getWelcomeMat } from 'ai/utils/sessionStorage';
import { EVENT_NAMES } from 'ai/analytics/events';
import { buildLyraAdviceFields } from 'ai/analytics/utils/sotFields';

export function trackWelcomeMatImpression() {
    if (getWelcomeMat()) {
        return;
    }

    processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
        data: {
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            actionInfo: 'superchat:welcome mat:view'
        }
    });

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: EVENT_NAMES.WELCOME_MAT_IMPRESSION,
            actionInfo: 'superchat:welcome mat:view',
            specificEventName: EVENT_NAMES.WELCOME_MAT_IMPRESSION,
            sotType: 'welcome_mat_impression',
            ...buildLyraAdviceFields()
        }
    });
}

export function trackWelcomeMatCategoryView({ categoryName }) {
    if (!categoryName) {
        return;
    }

    const normalizedName = categoryName.toLowerCase();

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: EVENT_NAMES.WELCOME_MAT_CATEGORY_VIEW,
            actionInfo: `superchat:welcome mat:${normalizedName}:view`,
            specificEventName: EVENT_NAMES.WELCOME_MAT_CATEGORY_VIEW,
            sotType: 'welcome_mat_category_click',
            ...buildLyraAdviceFields()
        }
    });
}

export function trackWelcomeMatPromptClick({ cardName, slotNumber, pageName }) {
    if (!cardName || slotNumber === null || slotNumber === undefined) {
        return;
    }

    const normalizedCardName = cardName.toLowerCase();
    const actionInfo = `superchat:welcome mat:${normalizedCardName}:slot ${slotNumber}`;

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            actionInfo,
            linkName: actionInfo,
            specificEventName: actionInfo,
            sotType: 'welcome_mat_prompt_click',
            pageName: pageName || anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            ...buildLyraAdviceFields()
        }
    });
}

// GAI-6809: the Welcome Mat redesign (v2) tracks prompt clicks via the SiteCatalyst
// s.tl()/TrackAction (linkTrackingEvent) call carrying prop55 (actionInfo) and pageName,
// to maintain the existing Adobe Analytics welcome-mat interaction. v1 keeps the SOT/STAG
// call above (trackWelcomeMatPromptClick).
export function trackWelcomeMatPromptClickV2({ cardName, slotNumber, pageName }) {
    if (!cardName || slotNumber === null || slotNumber === undefined) {
        return;
    }

    const normalizedCardName = cardName.toLowerCase();
    const actionInfo = `superchat:welcome mat:${normalizedCardName}:slot ${slotNumber}`;

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            pageName: pageName || anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            actionInfo // prop55 = superchat:welcome mat:<card name>:slot <#>
        }
    });
}
